import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiCall } from 'services';

const cancelTransfer = async (certificateId: string) => {
  await createApiCall({
    method: 'POST',
    url: `/transfer/customer/cancel/${certificateId}`,
    throwError: true,
  });
};

export const useCancelTransfer = ({ certificateId }: { certificateId: string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (certificateId: string) => {
      return cancelTransfer(certificateId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['certificates'] });
      queryClient.invalidateQueries({ queryKey: ['certificate-public', certificateId] });
    },
  });
};
